import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  return (
    <div className="padding">
      <div className="about">
        <Helmet>
          <title>privacy policy - dubu</title>
          <meta
            name="keywords"
            content="privacy, kpop, dubu, database, kpop credits"
          />
          <meta name="description" content="dubu Privacy Policy" />
        </Helmet>
        <h3>🔒 privacy policy</h3>
        <br></br>

        <p><strong>what we collect</strong></p>
        <p>
          When you sign in with Google, we collect your name and email address to create and manage your account. We also use Google Analytics to understand how users interact with our site.
        </p>
        <br></br>

        <p><strong>how your data is used</strong></p>
        <p>
          Your data is used to authenticate your account and improve our services.
          We do not sell or share your personal data with third parties for marketing purposes.
          Information may be shared with Google, which may combine it with other data from your use of their services.
        </p>
        <br></br>

        <p><strong>GPDR notice (EU users)</strong></p>
        <p>
          We process your data based on your consent or our legitimate interest.
          You may access, correct, or delete your data by contacting us at <Link to="mailto:contact.dubu@gmail.com">contact.dubu@gmail.com</Link>.
        </p>
        <br></br>

        <p><strong>questions?</strong> email us at <Link to="mailto:contact.dubu@gmail.com">contact.dubu@gmail.com</Link></p>
        <br></br>
        <p><i>effective date: 05/08/2025</i></p>
      </div>
    </div >
  );
};

export default PrivacyPolicyPage;
